import ContatoModel from "@/models/cliente/contato.model";
import EnderecoModel from "@/models/cliente/endereco.model";
import ClienteModel from "@/models/cliente/cliente.model";
import SinalizacaoModel from "@/models/cliente/sinalizacao.model";

class SinalizacaoResponse {

    itens: Array<SinalizacaoModel>;
    cliente: ClienteModel;
    endereco: EnderecoModel;
    contatos: Array<ContatoModel>;

    constructor() {
        this.itens = [];
        this.cliente = new ClienteModel();
        this.endereco = new EnderecoModel();
        this.contatos = [];
    }

}

export default SinalizacaoResponse;
